// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const keyboardSections: PaneSection[] = [
  {
    section: 'settings-keyboard-intro',
    title: 'Keyboard shortcuts',
    body: 'This pane lists everything you can do from the keyboard. Use it as a quick reference for formatting, writing, and moving around.',
  },
  {
    section: 'settings-keyboard-text-formatting',
    title: 'Text formatting',
    body: 'These shortcuts style the text in the message field, like bold, italic, and lists. They work on a selection or as you type.',
  },
  {
    section: 'settings-keyboard-composing',
    title: 'Composing and sending',
    body: 'These cover writing and sending a message, including how to add a new line and edit your last one. You can also type simple marks and let them format automatically.',
  },
  {
    section: 'settings-keyboard-autocomplete',
    title: 'Autocomplete menu',
    body: 'When the suggestion menu pops up for a mention or an emoji, use these keys to pick an option or close the menu.',
  },
  {
    section: 'settings-keyboard-navigation',
    title: 'Navigation',
    body: 'These let you jump around the app from the keyboard, like opening settings, switching conversations, or closing a dialog.',
  },
];
